(function () {
  window.theme = window.theme || {};
  // Kurv-endpoints fra temaets routes (theme.liquid), saa markeder med sprogpraefiks (fx /nb/cart) virker.
  var cartRoutes = (window.theme && window.theme.routes) || {};
  var CART_URL = cartRoutes.cart || "/cart.js";
  var CART_PAGE_URL = cartRoutes.cartPage || "/cart";
  var CART_ADD_URL = cartRoutes.cartAdd || "/cart/add.js";
  var CART_CHANGE_URL = cartRoutes.cartChange || "/cart/change.js";
  var CART_UPDATE_URL = cartRoutes.cartUpdate || "/cart/update.js";

  // UI-tekster fra locales via theme.strings (theme.liquid), dansk fallback hvis noeglen mangler (audit 5.2)
  function wlString(key, fallback) {
    var strings = (window.theme && theme.strings) || {};
    return typeof strings[key] === "string" && strings[key] ? strings[key] : fallback;
  }

  function getCartDrawer() {
    return document.getElementById("CartDrawer");
  }

  function getCartFormInner() {
    return document.querySelector("#CartDrawerForm .drawer__inner");
  }

  function getEmptyState() {
    return document.querySelector("#CartDrawerForm .drawer__cart-empty");
  }

  function formatMoney(cents) {
    // Temaets formatering (theme.Currency) med butikkens format for det aktuelle marked (theme.settings.moneyFormat).
    // Ingen egen overskrivning af Shopify.formatMoney laengere (audit 5.1).
    var format = (window.theme && theme.settings && theme.settings.moneyFormat) || "";
    if (format && window.theme.Currency && typeof theme.Currency.formatMoney === "function") {
      return theme.Currency.formatMoney(Math.round(cents), format);
    }
    return (cents / 100).toFixed(2).replace(".", ",");
  }

  function parseJSONSafe(value, fallback = null) {
    try {
      return JSON.parse(value);
    } catch (error) {
      return fallback;
    }
  }

  function getVisibleCartCount(cartData) {
    let visibleCount = 0;

    if (cartData && Array.isArray(cartData.items)) {
      cartData.items.forEach(function (item) {
        const isBundleChild = item?.properties?._bundle_role === "child";
        if (!isBundleChild) {
          visibleCount += item.quantity || 0;
        }
      });
    }

    return visibleCount;
  }

  function initVariantSelectors(scope = document) {
    const selects = scope.querySelectorAll(".variant-select");

    selects.forEach(function (select) {
      if (select.dataset.variantSelectorBound === "true") return;
      select.dataset.variantSelectorBound = "true";

      const variantsJSON = select.dataset.variants;
      if (!variantsJSON) return;

      const variants = parseJSONSafe(variantsJSON, []);
      if (!Array.isArray(variants) || !variants.length) return;

      const productEl = select.closest(".custom-related-product");
      const productData = productEl?.dataset?.product ? parseJSONSafe(productEl.dataset.product, null) : null;

      select.addEventListener("change", function () {
        const selectedId = this.value;
        const variant = variants.find(function (v) {
          return String(v.id) === String(selectedId);
        });

        if (!variant) return;

        const qtyWrappers = productEl?.querySelectorAll(".custom-qty-wrapper");
        let currentQty = 1;

        qtyWrappers?.forEach(function (wrapper) {
          const qtyInput = wrapper.querySelector("input.qty-input");
          if (qtyInput) {
            currentQty = parseInt(qtyInput.value, 10) || 1;
          }
        });

        const priceContainer = productEl?.querySelector(".custom-related-product__price");
        if (!priceContainer) return;

        priceContainer.innerHTML = "";

        if (variant.compare_at_price > variant.price) {
          const wasPrice = document.createElement("span");
          wasPrice.className = "was-price";
          wasPrice.style.textDecoration = "line-through";
          wasPrice.style.color = "#888";
          wasPrice.textContent = formatMoney(variant.compare_at_price);
          priceContainer.appendChild(wasPrice);
        }

        const currentPrice = document.createElement("span");
        currentPrice.className = "current-price";
        currentPrice.style.fontWeight = "600";
        currentPrice.style.marginLeft = "5px";
        currentPrice.textContent = formatMoney(variant.price);
        priceContainer.appendChild(currentPrice);

        // Badge pr. variant fra data-variant-badges (variantens sticky-badge-metafelt),
        // ellers produktets badge_text. Variant-JSON'et selv indeholder ingen metafelter.
        // Varianter med foerpris (tilbud) viser ingen badge: tilbud og 2 stk-pris koerer aldrig samtidig.
        const variantBadges = productEl?.dataset?.variantBadges
          ? parseJSONSafe(productEl.dataset.variantBadges, {})
          : {};
        let badgeText = variant.compare_at_price > variant.price
          ? null
          : (variantBadges && variantBadges[String(variant.id)]) ||
            productEl?.dataset?.productBadge ||
            null;

        if (badgeText) {
          const badge = document.createElement("div");
          badge.className = "custom-badge-text";
          badge.style.marginTop = "5px";
          badge.style.fontSize = "13px";
          badge.style.color = "#444";
          badge.textContent = badgeText;
          priceContainer.appendChild(badge);
        }

        qtyWrappers?.forEach(function (wrapper) {
          const qtyInput = wrapper.querySelector("input.qty-input");
          if (qtyInput) {
            qtyInput.value = currentQty;
            qtyInput.setAttribute("value", currentQty);
          }
        });
      });
    });
  }

  function initAjaxAddToCart(scope = document) {
    const forms = scope.querySelectorAll('.custom-related-product form[action*="/cart/add"]');

    forms.forEach(function (form) {
      if (form.dataset.ajaxListenerAttached === "true") return;
      form.dataset.ajaxListenerAttached = "true";

      const variantSelect = form.querySelector('select[name="id"]');
      const submitBtn = form.querySelector('button[type="submit"], .add-to-cart');

      if (variantSelect && submitBtn) {
        submitBtn.disabled = !variantSelect.value;

        variantSelect.addEventListener("change", function () {
          submitBtn.disabled = !this.value;
        });
      }

      form.addEventListener("submit", async function (e) {
        e.preventDefault();

        const variantInput = form.querySelector('input[name="id"], select[name="id"]');
        const qtyInput = form.querySelector('input[name="quantity"]');
        const quantity = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
        const originalBtnText = submitBtn ? submitBtn.textContent : "";

        if (!variantInput || !variantInput.value) {
          if (submitBtn) {
            submitBtn.textContent = wlString("wlChooseVariant", "Vælg variant");
            setTimeout(function () {
              submitBtn.textContent = originalBtnText || wlString("wlAddToCart", "Tilføj til kurv");
            }, 2000);
          }
          return;
        }

        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = wlString("wlAdding", "Tilføjer...");
        }

        try {
          const formData = new FormData(form);
          formData.set("id", variantInput.value);
          formData.set("quantity", quantity);

          const res = await fetch(CART_ADD_URL, {
            method: "POST",
            body: formData,
            headers: { Accept: "application/json" },
            credentials: "same-origin"
          });

          if (!res.ok) throw new Error("Fejl ved tilføjelse");

          const data = await res.json();

          if (submitBtn) {
            submitBtn.textContent = wlString("wlAdded", "Tilføjet!");
          }

          // refreshCartContents (lytter paa ajaxProduct:added) opdaterer ogsaa kurv-boblen,
          // saa der hentes ikke /cart.js en ekstra gang her.
          document.dispatchEvent(
            new CustomEvent("ajaxProduct:added", {
              detail: { product: data }
            })
          );

          setTimeout(function () {
            if (submitBtn) {
              submitBtn.textContent = originalBtnText || wlString("wlAddToCart", "Tilføj til kurv");
              submitBtn.disabled = false;
            }
          }, 1000);
        } catch (error) {
          console.error("Fejl ved tilføjelse:", error);

          if (submitBtn) {
            submitBtn.textContent = wlString("wlError", "Fejl");
            setTimeout(function () {
              submitBtn.textContent = originalBtnText || wlString("wlAddToCart", "Tilføj til kurv");
              submitBtn.disabled = false;
            }, 2000);
          }
        }
      });
    });
  }

  // Variant-metafelter ved variantskift: custom_html-wrapperen og badges over titlen
  // (snippets/custom-product-badges.liquid) opdateres fra ét ?view=json-kald
  // (templates/product.json.liquid). Erstatter den tidligere jQuery-udgave i badge-snippetten.
  function renderVariantBadges(container, variant) {
    container.innerHTML = "";

    if (String(variant.is_bestseller) === "true") {
      const bestseller = document.createElement("div");
      bestseller.className = "custom--product-badge custom--product-badge__bestseller";
      bestseller.textContent = container.dataset.bestsellerText || "";
      container.appendChild(bestseller);
    }

    const badges = Array.isArray(variant.metafield_custom_badges) ? variant.metafield_custom_badges : [];
    badges.forEach(function (badge) {
      const el = document.createElement("div");
      el.className = "custom--product-badge custom--product-badge__" + encodeURIComponent(String(badge).toLowerCase().replace(/ /g, "-"));
      el.textContent = badge;
      container.appendChild(el);
    });
  }

  function initVariantMetafieldHTML() {
    if (document.body.dataset.variantMetafieldBound === "true") return;
    document.body.dataset.variantMetafieldBound = "true";

    document.addEventListener("variantChange", function (event) {
      const wrapper = document.querySelector(".custom--product-variant-custom-html__wrapper");
      const badgeContainer = document.querySelector("[data-wl-product-badges]");
      const variantId = event.detail?.variant?.id?.toString();

      if ((!wrapper && !badgeContainer) || !variantId) return;

      const fullUrl = window.location.href.split("?")[0] + "?view=json";

      fetch(fullUrl, { credentials: "same-origin" })
        .then(function (res) {
          return res.json();
        })
        .then(function (json) {
          const variant = json.variants?.find(function (v) {
            return String(v.id) === String(variantId);
          });

          if (wrapper) {
            if (variant?.metafield_custom_html) {
              const temp = document.createElement("textarea");
              temp.innerHTML = variant.metafield_custom_html;
              wrapper.innerHTML = temp.value;
            } else {
              wrapper.innerHTML = "";
            }
          }

          if (badgeContainer && variant) {
            renderVariantBadges(badgeContainer, variant);
          }
        })
        .catch(function (err) {
          console.error("Fejl ved AJAX/metafield load:", err);
        });
    }, true);
  }

  function initGlobalQtyButtons() {
    if (window.__customQtyClickBound) return;
    window.__customQtyClickBound = true;

    document.addEventListener("click", function (e) {
      if (e.target.closest("#CartDrawer")) return;

      const plusBtn = e.target.closest(".qty-plus");
      const minusBtn = e.target.closest(".qty-minus");

      if (plusBtn) {
        e.preventDefault();
        e.stopPropagation();

        const wrapper = plusBtn.closest(".custom-qty-wrapper");
        const input = wrapper?.querySelector(".qty-input");

        if (input) {
          const val = parseInt(input.value, 10) || 1;
          input.value = val + 1;
          input.setAttribute("value", input.value);
        }

        return;
      }

      if (minusBtn) {
        e.preventDefault();
        e.stopPropagation();

        const wrapper = minusBtn.closest(".custom-qty-wrapper");
        const input = wrapper?.querySelector(".qty-input");

        if (input) {
          const val = parseInt(input.value, 10) || 1;
          if (val > 1) {
            input.value = val - 1;
            input.setAttribute("value", input.value);
          }
        }
      }
    });
  }

  function syncReadMoreButton(desc) {
    const sibling = desc.nextElementSibling;
    if (sibling && sibling.matches && sibling.matches("[data-collection-readmore]")) {
      sibling.textContent = desc.classList.contains("expanded") ? wlString("wlReadLess", "Læs mindre") : wlString("wlReadMore", "Læs mere");
    }
  }

  function initTextToggles() {
    if (document.body.dataset.textToggleBound === "true") return;
    document.body.dataset.textToggleBound = "true";

    document.addEventListener("click", function (e) {
      // Tydelig "Læs mere/Læs mindre"-knap
      const readmore = e.target.closest("[data-collection-readmore]");
      if (readmore) {
        const desc = readmore.previousElementSibling;
        if (desc && desc.matches("[data-collection-toggle]")) {
          desc.classList.toggle("expanded");
          syncReadMoreButton(desc);
          const heroEl = desc.closest(".wl-collection-hero--image");
          if (heroEl) {
            heroEl.classList.toggle("hero-is-expanded", desc.classList.contains("expanded"));
          }
        }
        return;
      }

      const toggle = e.target.closest("[data-collection-toggle]");
      if (!toggle) return;

      toggle.classList.toggle("expanded");
      syncReadMoreButton(toggle);

      const hero = toggle.closest(".wl-collection-hero--image");
      if (hero) {
        hero.classList.toggle("hero-is-expanded", toggle.classList.contains("expanded"));
      }
    });
  }

  function initCollectionReadMore(scope = document) {
    scope.querySelectorAll("[data-collection-toggle]").forEach(function (desc) {
      if (desc.dataset.readmoreBound === "true") return;
      desc.dataset.readmoreBound = "true";

      // Tilfoej kun knappen hvis teksten faktisk er afkortet
      if (desc.scrollHeight <= desc.clientHeight + 2) return;
      if (desc.nextElementSibling && desc.nextElementSibling.matches("[data-collection-readmore]")) return;

      const btn = document.createElement("button");
      btn.type = "button";
      btn.className = "collection-hero__readmore";
      btn.setAttribute("data-collection-readmore", "");
      btn.textContent = wlString("wlReadMore", "Læs mere");
      desc.insertAdjacentElement("afterend", btn);
    });
  }

  // Opsalg i draweren (snippets/cart-drawer.liquid): skjul varer der allerede ligger i kurven,
  // og hele blokken hvis ingen er tilbage. Renderes ikke om, kun vist/skjult.
  function updateCartUpsells(cartData) {
    var container = document.querySelector("[data-cart-upsell-container]");
    if (!container) return;
    var handlesInCart = {};
    ((cartData && cartData.items) || []).forEach(function (item) {
      if (item.handle) handlesInCart[item.handle] = true;
    });
    var visible = 0;
    container.querySelectorAll("[data-cart-upsell]").forEach(function (el) {
      var hide = !!handlesInCart[el.dataset.handle];
      el.hidden = hide;
      if (!hide) visible += 1;
    });
    container.hidden = visible === 0;
  }

  function updateCartCountBubble(cartData) {
    const visibleCount = getVisibleCartCount(cartData);
    const bubbles = document.querySelectorAll(
      ".cart-link__bubble, .cart-link__bubble--visible, [data-cart-count], .site-header__cart-count"
    );

    bubbles.forEach(function (bubble) {
      bubble.textContent = visibleCount;

      if (bubble.classList.contains("cart-link__bubble") || bubble.classList.contains("cart-link__bubble--visible")) {
        if (visibleCount > 0) {
          bubble.classList.add("cart-link__bubble--visible");
          bubble.style.display = "";
        } else {
          bubble.classList.remove("cart-link__bubble--visible");
          bubble.style.display = "none";
        }
      }
    });
  }

  function getFreeShippingBar() {
    return document.querySelector("#CartDrawer free-shipping-bar") || document.querySelector("free-shipping-bar");
  }

  function calculateFreeShippingData(cart) {
    const items = Array.isArray(cart?.items) ? cart.items : [];
    const discountApplications = Array.isArray(cart?.cart_level_discount_applications)
      ? cart.cart_level_discount_applications
      : [];

    const priceForItems = items
      .filter(function (item) {
        return item && item.requires_shipping;
      })
      .reduce(function (sum, item) {
        return sum + (item.final_line_price || 0);
      }, 0);

    const cartDiscount = discountApplications.reduce(function (sum, discountAllocation) {
      return sum + (discountAllocation.total_allocated_amount || 0);
    }, 0);

    return {
      totalPrice: Math.max(0, priceForItems - cartDiscount),
      hasShippableItems: items.some(function (item) {
        return item && item.requires_shipping;
      })
    };
  }

  function renderFreeShippingBarFromCart(cartData) {
    const freeShippingBar = getFreeShippingBar();
    if (!freeShippingBar) return;

    const threshold = parseFloat(freeShippingBar.getAttribute("threshold")) || 0;
    const progressBar = freeShippingBar.querySelector("progress-bar");
    const messageTarget = freeShippingBar.querySelector("span");
    if (!progressBar || !messageTarget) return;

    const shippingData = calculateFreeShippingData(cartData);

    if (!shippingData.hasShippableItems || threshold <= 0) {
      freeShippingBar.style.display = "none";
      return;
    }

    freeShippingBar.style.display = "";

    const safeThreshold = threshold > 0 ? threshold : 0;
    const remainingAmount = Math.max(0, safeThreshold - shippingData.totalPrice);
    const progressPercentage = safeThreshold > 0
      ? Math.min(100, (shippingData.totalPrice / safeThreshold) * 100)
      : 0;

    progressBar.style.setProperty("--progress", progressPercentage / 100);
    progressBar.setAttribute("aria-valuenow", String(Math.round(progressPercentage)));

    const reachedMessage = freeShippingBar.getAttribute("reached-message") || "";
    const unreachedMessage = freeShippingBar.getAttribute("unreached-message") || "";

    const message =
      safeThreshold > 0 && shippingData.totalPrice >= safeThreshold
        ? reachedMessage
        : unreachedMessage.replace("[remaining_amount]", formatMoney(remainingAmount));

    messageTarget.innerHTML = message;
  }

  let refreshInProgress = false;

  function updateCartSummary(cartData) {
    const subtotalEl = document.querySelector("[data-subtotal]");
    if (subtotalEl) subtotalEl.innerHTML = formatMoney(cartData.total_price);

    const vatRow = document.querySelector("[data-cart-vat-row]");
    const vatEl = document.querySelector("[data-cart-vat]");
    const vatRate = vatRow ? parseFloat(vatRow.getAttribute("data-vat-rate")) || 0 : 0;
    if (vatEl && vatRate > 0) vatEl.innerHTML = formatMoney(Math.round((cartData.total_price * vatRate) / (100 + vatRate)));

    const savingsRow = document.querySelector("[data-cart-savings-row]");
    const savingsEl = document.querySelector("[data-cart-savings]");
    const savings = Math.max(0, (cartData.original_total_price || 0) - (cartData.total_price || 0));

    if (savingsRow && savingsEl) {
      if (savings > 0) {
        savingsRow.classList.remove("hide");
        savingsEl.innerHTML = "-" + formatMoney(savings);
      } else {
        savingsRow.classList.add("hide");
        savingsEl.innerHTML = "";
      }
    }
  }

  function updateCartShippingText(cartData) {
    const el = document.querySelector("[data-cart-shipping]");
    if (!el) return;

    const shippingData = calculateFreeShippingData(cartData);
    const threshold = parseFloat(getFreeShippingBar()?.getAttribute("threshold")) || 0;

    el.textContent = threshold > 0 && shippingData.totalPrice >= threshold ? wlString("wlFreeShipping", "Gratis fragt") : wlString("wlShippingAtCheckout", "Beregnes ved checkout");
  }

  function toggleEmptyCart(cartData) {
  var cartDrawer = document.getElementById("CartDrawer");
  var cartInner = document.querySelector("#CartDrawerForm .drawer__inner");
  var emptyState = document.querySelector("#CartDrawerForm .drawer__cart-empty");

  if (!cartDrawer || !cartInner || !emptyState) return;

  if (cartData.item_count === 0) {
    cartDrawer.classList.add("is-empty");
  } else {
    cartDrawer.classList.remove("is-empty");
  }
}

  function changeCartItemByKey(key, quantity) {
  return fetch(CART_CHANGE_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json"
    },
    credentials: "same-origin",
    body: JSON.stringify({
      id: key,
      quantity: quantity
    })
  }).then(function (response) {
    return response.json();
  });
}

  // Flere linjer i ét kald (/cart/update.js accepterer line item keys), saa parent og pudebetraek
  // aendres atomisk. Fejler kaldet, aendres ingen af dem.
  function updateCartLinesByKey(updates) {
    return fetch(CART_UPDATE_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      credentials: "same-origin",
      body: JSON.stringify({ updates: updates })
    }).then(function (response) {
      if (!response.ok) {
        return readCartError(response, "").then(function (message) {
          throw new Error(message || "Kurven kunne ikke opdateres");
        });
      }
      return response.json();
    });
  }

  // Shopifys fejltekst fra et 4xx-svar (description/message), ellers fallback
  function readCartError(response, fallback) {
    return response
      .json()
      .then(function (data) {
        var text = data && (data.description || data.message);
        return typeof text === "string" && text ? text : fallback;
      })
      .catch(function () {
        return fallback;
      });
  }

  // Fejlbesked i formularen med temaets egen .errors-stil (samme som theme.js AjaxProduct)
  function showFormError(form, message) {
    if (!form || !message) return;
    var existing = form.querySelector(".errors");
    if (existing) existing.remove();
    var errorDiv = document.createElement("div");
    errorDiv.className = "errors text-center";
    errorDiv.setAttribute("role", "alert");
    errorDiv.textContent = message;
    form.append(errorDiv);
    window.setTimeout(function () {
      if (errorDiv.parentNode) errorDiv.remove();
    }, 8000);
  }

function updateLineItem(key, quantity) {
  if (!key) return Promise.reject(new Error("Manglende line item key"));

  quantity = parseInt(quantity, 10);
  if (isNaN(quantity) || quantity < 0) {
    quantity = 0;
  }

  return fetch(CART_URL, {
    credentials: "same-origin",
    cache: "no-store"
  })
    .then(function (response) {
      return response.json();
    })
    .then(function (cart) {
      if (!cart || !Array.isArray(cart.items)) {
        throw new Error("Kunne ikke hente kurven");
      }

      var targetItem = cart.items.find(function (item) {
        return item.key === key;
      });

      if (!targetItem) {
        throw new Error("Kunne ikke finde line item i kurven");
      }

      var isBundleParent =
        targetItem.properties &&
        targetItem.properties._bundle_type === "bedding_set" &&
        targetItem.properties._bundle_role === "parent";

      if (!isBundleParent) {
        return changeCartItemByKey(key, quantity);
      }

      var childLinkKey = targetItem.properties._child_link_key;
      var qtyPerSet = parseInt(targetItem.properties._linked_pillow_quantity_per_set || "1", 10);

      if (isNaN(qtyPerSet) || qtyPerSet < 1) {
        qtyPerSet = 1;
      }

      if (!childLinkKey) {
        return changeCartItemByKey(key, quantity);
      }

      var childItem = cart.items.find(function (item) {
        return item.properties &&
          item.properties._bundle_type === "bedding_set" &&
          item.properties._bundle_role === "child" &&
          item.properties._bundle_key === childLinkKey;
      });

      var currentParentQty = parseInt(targetItem.quantity || 0, 10);
      var qtyDelta = quantity - currentParentQty;
      var childDelta = qtyDelta * qtyPerSet;

      if (!childItem) {
        return changeCartItemByKey(key, quantity);
      }

      var newChildQty = quantity === 0
        ? Math.max(0, (childItem.quantity || 0) - (currentParentQty * qtyPerSet))
        : Math.max(0, (childItem.quantity || 0) + childDelta);

      var updates = {};
      updates[key] = quantity;
      updates[childItem.key] = newChildQty;
      return updateCartLinesByKey(updates);
    })
    .then(function () {
      return refreshCartContents();
    })
    .catch(function (error) {
      // Fx lagergraense paa pudebetraekket: vis Shopifys besked i draweren og synk visningen med serveren
      var drawerForm = document.getElementById("CartDrawerForm") || document.getElementById("CartPageForm");
      showFormError(drawerForm, error && error.message);
      return refreshCartContents();
    });
}

  function addUpsellToCart(variantId) {
    return fetch(CART_ADD_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      credentials: "same-origin",
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1 }]
      })
    })
      .then(function (res) {
        if (!res.ok) throw new Error("Upsell fejl");
        return res.json();
      })
      .then(function () {
        return refreshCartContents();
      });
  }

  // Qty-knapper i kurven. Vi haandterer ALLE kurv-linjer (bundle som ikke-bundle)
  // via een capture-fase-listener paa document, og stopper Impulses egen
  // theme.QtySelector i ogsaa at koere paa samme klik (stopImmediatePropagation).
  //
  // Hvorfor: Impulses QtySelector (a) opdaterer kun den klikkede linje uden at
  // synkronisere medfoelgende pudebetraek, og (b) bindes kun naar en linje
  // foerst renderes, saa nyligt AJAX-tilfoejede varer ikke virkede foer reload.
  // Vores updateLineItem haandterer baade bundle-parent (synkroniserer pude) og
  // almindelige varer, saa een listener daekker alt paalideligt.
  function bindQtyButtons() {
    if (window.__wlCartQtyBound) return;
    window.__wlCartQtyBound = true;

    document.addEventListener(
      "click",
      function (e) {
        var button = e.target.closest(".js-qty__adjust");
        if (!button) return;

        // Kun inde i kurven (drawer eller cart-side), ikke fx produktside-qty.
        if (!button.closest("#CartDrawer, #CartDrawerForm, #CartPageForm")) return;

        var wrapper = button.closest(".js-qty__wrapper");
        if (!wrapper) return;

        var input = wrapper.querySelector(".js-qty__num");
        if (!input) return;

        // Overtag klikket helt saa Impulses QtySelector ikke ogsaa koerer.
        e.preventDefault();
        e.stopImmediatePropagation();

        if (button.disabled) return;

        var key = input.dataset.id;
        var currentQty = parseInt(input.value, 10);
        if (isNaN(currentQty)) currentQty = 0;

        var newQty = currentQty;

        if (button.classList.contains("js-qty__adjust--plus")) {
          newQty = currentQty + 1;

          var maxQty = parseInt(input.dataset.maxQty || "0", 10);
          if (maxQty > 0 && newQty > maxQty) {
            return;
          }
        }

        if (button.classList.contains("js-qty__adjust--minus")) {
          newQty = Math.max(currentQty - 1, 0);
        }

        if (newQty === currentQty) return;

        pendingCartFocus = {
          key: key,
          selector: button.classList.contains("js-qty__adjust--plus") ? ".js-qty__adjust--plus" : ".js-qty__adjust--minus"
        };
        button.disabled = true;
        input.value = newQty;

        updateLineItem(key, newQty).finally(function () {
          button.disabled = false;
        });
      },
      true
    );
  }

  function bindRemoveButtons() {
    if (document.body.dataset.removeBound === "true") return;
    document.body.dataset.removeBound = "true";

    document.addEventListener("click", function (event) {
      var cartDrawer = getCartDrawer();
      if (!cartDrawer) return;

      var button = event.target.closest(".cart__remove-button");
      if (!button || !cartDrawer.contains(button)) return;

      event.preventDefault();
      event.stopPropagation();

      if (button.disabled) return;
      button.disabled = true;

      var key = button.dataset.removeKey;
      if (!key) {
        button.disabled = false;
        return;
      }

      pendingCartFocus = { key: key, selector: ".cart__remove-button" };
      updateLineItem(key, 0).finally(function () {
        button.disabled = false;
      });
    });
  }

  function bindUpsellButtons() {
    if (document.body.dataset.upsellBound === "true") return;
    document.body.dataset.upsellBound = "true";

    document.addEventListener("click", function (event) {
      var button = event.target.closest(".add-upsell-to-cart");
      if (!button) return;

      event.preventDefault();

      if (button.disabled) return;

      var variantId = button.dataset.id;
      button.disabled = true;
      button.textContent = wlString("wlAdding", "Tilføjer...");

      addUpsellToCart(variantId)
        .then(function () {
          if (!button.closest("#CartDrawer, #CartDrawerForm, #CartPageForm")) {
            document.dispatchEvent(new CustomEvent("cart:open"));
          }
        })
        .catch(function (error) {
          console.error("Fejl ved tilkøb:", error);
        })
        .finally(function () {
          button.disabled = false;
          button.textContent = wlString("wlAddToCartShort", "Læg i kurv");
        });
    });
  }

  function bindSummaryToggle() {
    var toggle = document.getElementById("cartSummaryToggle");
    var details = document.getElementById("cartSummaryDetails");

    if (!toggle || !details) return;
    if (toggle.dataset.bound === "true") return;
    toggle.dataset.bound = "true";

    toggle.addEventListener("click", function () {
      var isOpen = toggle.getAttribute("aria-expanded") === "true";

      toggle.setAttribute("aria-expanded", isOpen ? "false" : "true");
      toggle.textContent = isOpen ? wlString("wlShowDetails", "Vis detaljer") : wlString("wlHideDetails", "Skjul detaljer");
      details.hidden = isOpen;
    });
  }

  function bindGiftQuestion() {
    var drawer = getCartDrawer();
    if (!drawer) return;

    var input = drawer.querySelector('input[name="attributes[Er dette en gave?]"]');
    var dropdown = document.getElementById("giftWrapDropdown");

    if (!input) return;
    if (input.dataset.bound === "true") return;
    input.dataset.bound = "true";

    input.addEventListener("change", function () {
      if (dropdown) {
        dropdown.hidden = !this.checked;
      }

      fetch(CART_UPDATE_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        credentials: "same-origin",
        body: JSON.stringify({
          attributes: {
            "Er dette en gave?": this.checked ? "Ja" : ""
          }
        })
      }).catch(function (error) {
        console.error("Fejl ved gaveattribut:", error);
      });
    });
  }

  function updateGiftWrapAvailability(cartData, flags) {
    var drawer = getCartDrawer();
    if (!drawer) return;

    var giftSection = drawer.querySelector("[data-gift-question]");
    if (!giftSection) return;

    if (flags) {
      giftSection.dataset.hasWrappable = flags.hasWrappable ? "true" : "false";
      giftSection.dataset.hasUnwrappable = flags.hasUnwrappable ? "true" : "false";
    }

    var hasWrappable = giftSection.dataset.hasWrappable === "true";
    var hasUnwrappable = giftSection.dataset.hasUnwrappable === "true";

    var giftWrapItem = null;
    if (cartData && cartData.items) {
      giftWrapItem = cartData.items.find(function (item) {
        return item.handle === "gaveindpakning";
      }) || null;
    }
    var giftWrapInCart = giftWrapItem !== null;

    // Ligger gaveindpakningen i kurven uden at der er noget at pakke ind
    // (kun undtagne varer tilbage), fjernes den automatisk (Mads' beslutning 2. juli 2026).
    if (giftWrapItem && !hasWrappable && hasUnwrappable) {
      changeCartItemByKey(giftWrapItem.key, 0)
        .then(function () {
          return refreshCartContents();
        })
        .catch(function (error) {
          console.error("Fejl ved auto-fjernelse af gaveindpakning:", error);
        });
    }

    var blocked = !hasWrappable;
    var addButton = giftSection.querySelector("[data-gift-wrap-add]");
    var blockedNote = giftSection.querySelector("[data-gift-wrap-blocked-note]");
    var warningNote = giftSection.querySelector("[data-gift-wrap-warning-note]");

    if (addButton) addButton.disabled = blocked;
    if (blockedNote) blockedNote.hidden = !blocked;
    if (warningNote) warningNote.hidden = !(giftWrapInCart && hasUnwrappable && !blocked);
  }

  // Tilkoebs-bokse paa produktsiden med kurv-betingelse (fx brodering kraever
  // et produkt med tagget brodering-mulig i kurven).
  function updateAddonUpsellRequirements(cartTags) {
    document.querySelectorAll("[data-addon-upsell][data-requires-cart-tag]").forEach(function (box) {
      var tag = box.dataset.requiresCartTag;
      if (!tag) return;

      var met = cartTags.indexOf(tag) !== -1;
      var addButton = box.querySelector(".add-upsell-to-cart");
      var note = box.querySelector("[data-addon-requires-note]");

      if (addButton) addButton.disabled = !met;
      if (note) note.hidden = met;
    });
  }

  // Ligger brodering i kurven uden broderbare varer (tag brodering-mulig),
  // og kurven ikke KUN bestaar af brodering, fjernes den automatisk,
  // samme princip som gaveindpakningen (Mads' beslutning 2. juli 2026).
  function updateEmbroideryCartRule(cartData, cartTags) {
    if (!cartData || !Array.isArray(cartData.items)) return;

    var embroideryItem = cartData.items.find(function (item) {
      return item.handle === "brodering-pa-sengetoj";
    });
    if (!embroideryItem) return;

    var hasEmbroiderable = cartTags.indexOf("brodering-mulig") !== -1;
    var hasOtherItems = cartData.items.some(function (item) {
      return item.handle !== "brodering-pa-sengetoj";
    });

    if (!hasEmbroiderable && hasOtherItems) {
      changeCartItemByKey(embroideryItem.key, 0)
        .then(function () {
          return refreshCartContents();
        })
        .catch(function (error) {
          console.error("Fejl ved auto-fjernelse af brodering:", error);
        });
    }
  }

  // Tilbudsboks under kurvlinjer (cart-item.liquid): ikonet aabner/lukker boksen, krydset lukker den
  function bindOfferButtons() {
    if (document.body.dataset.cartOfferBound === "true") return;
    document.body.dataset.cartOfferBound = "true";

    document.addEventListener("click", function (event) {
      var toggle = event.target.closest("[data-cart-offer-toggle]");
      var close = event.target.closest("[data-cart-offer-close]");
      if (!toggle && !close) return;
      event.preventDefault();

      var item = (toggle || close).closest(".cart__item");
      var box = item && item.querySelector("[data-cart-offer]");
      var toggleButton = item && item.querySelector("[data-cart-offer-toggle]");
      if (!box) return;

      var open = close ? false : box.hidden;
      box.hidden = !open;
      if (toggleButton) {
        toggleButton.setAttribute("aria-expanded", open ? "true" : "false");
        toggleButton.classList.toggle("is-open", open);
        if (close) toggleButton.focus();
      }
    });
  }

  function bindCartEvents() {
    bindQtyButtons();
    bindOfferButtons();
    bindRemoveButtons();
    bindUpsellButtons();
    bindSummaryToggle();
    bindGiftQuestion();
  }

  // Fokus i kurven efter AJAX-opdatering: [data-products].innerHTML erstattes, saa den knap der
  // havde fokus forsvinder. Vi husker linjens data-key og knaptypen foer opdateringen og saetter
  // fokus paa den tilsvarende knap bagefter, ellers paa "Vis detaljer" (eller luk-knappen naar kurven er tom).
  var CART_FOCUS_CONTROLS = [
    ".js-qty__adjust--minus",
    ".js-qty__adjust--plus",
    ".cart__remove-button",
    "[data-cart-offer-toggle]",
    "[data-cart-offer-close]"
  ];

  // Saettes af klik-handlerne foer knappen deaktiveres (en deaktiveret knap mister fokus i Chrome)
  var pendingCartFocus = null;

  // Linjens data-key skifter ved hver antal-aendring (Shopify laver ny key), saa vi husker ogsaa
  // variant-id (foerste del af key) og linjens placering som fallback.
  function cartItemIndex(productsContainer, key) {
    if (!productsContainer || !key) return -1;
    var items = productsContainer.querySelectorAll(".cart__item");
    return Array.prototype.findIndex.call(items, function (el) {
      return el.dataset.key === key;
    });
  }

  function rememberCartFocus(productsContainer) {
    var remembered = null;
    if (pendingCartFocus) {
      remembered = pendingCartFocus;
      pendingCartFocus = null;
    } else {
      var active = document.activeElement;
      if (!active || !productsContainer || !productsContainer.contains(active)) return null;
      var item = active.closest(".cart__item");
      var selector = CART_FOCUS_CONTROLS.find(function (sel) {
        return active.matches(sel);
      });
      if (!item || !selector) return null;
      remembered = { key: item.dataset.key, selector: selector };
    }
    remembered.index = cartItemIndex(productsContainer, remembered.key);
    remembered.variant = String(remembered.key || "").split(":")[0];
    return remembered;
  }

  function restoreCartFocus(productsContainer, remembered) {
    var target = null;
    if (remembered && remembered.key && productsContainer) {
      var items = Array.prototype.slice.call(productsContainer.querySelectorAll(".cart__item"));
      var item = items.find(function (el) {
        return el.dataset.key === remembered.key;
      });
      if (!item && remembered.variant) {
        item = items.find(function (el) {
          return String(el.dataset.key || "").split(":")[0] === remembered.variant;
        });
      }
      if (!item && remembered.index >= 0 && remembered.index < items.length && remembered.selector !== ".cart__remove-button") {
        item = items[remembered.index];
      }
      target = item ? item.querySelector(remembered.selector) : null;
    }
    if (!target || target.disabled) {
      var toggle = document.getElementById("cartSummaryToggle");
      target = toggle && toggle.offsetParent !== null ? toggle : null;
    }
    if (!target) {
      var drawer = getCartDrawer();
      target = drawer ? drawer.querySelector(".js-drawer-close") : null;
    }
    if (target && typeof target.focus === "function") {
      target.focus({ preventScroll: true });
    }
  }

  // Kort skaermlaeser-besked (role=status i cart-drawer.liquid) med ny subtotal
  function announceCartUpdated(cartData) {
    var status = document.querySelector("[data-cart-status]");
    if (!status || !cartData) return;
    var text = status.dataset.textUpdated || "";
    status.textContent = "";
    window.setTimeout(function () {
      status.textContent = (text + " " + formatMoney(cartData.total_price)).trim();
    }, 50);
  }

  function refreshCartContents() {
    if (refreshInProgress) return Promise.resolve();
    refreshInProgress = true;

    return Promise.all([
      fetch(CART_PAGE_URL + "?view=ajax&_=" + Date.now(), {
        credentials: "same-origin",
        cache: "no-store"
      }).then(function (res) {
        return res.text();
      }),
      fetch(CART_URL, {
        credentials: "same-origin",
        cache: "no-store"
      }).then(function (res) {
        return res.json();
      })
    ])
      .then(function (results) {
        const html = results[0];
        const cartData = results[1];
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const cartDrawer = getCartDrawer();

        if (!cartDrawer) {
          if (window.location.pathname === CART_PAGE_URL) {
            window.location.reload();
          }
          return;
        }

        const ajaxProducts = doc.querySelector("[data-products]");
        const currentProducts = cartDrawer.querySelector("[data-products]");
        const rememberedFocus = rememberCartFocus(currentProducts);

        if (ajaxProducts && currentProducts) {
          currentProducts.innerHTML = ajaxProducts.innerHTML;
        }

        const ajaxDiscounts = doc.querySelector("[data-discounts]");
        const currentDiscounts = cartDrawer.querySelector("[data-discounts]");

        if (ajaxDiscounts && currentDiscounts) {
          currentDiscounts.innerHTML = ajaxDiscounts.innerHTML;
          currentDiscounts.className = ajaxDiscounts.className;
        }

        if (ajaxProducts) {
          updateGiftWrapAvailability(cartData, {
            hasWrappable: ajaxProducts.dataset.hasWrappable === "true",
            hasUnwrappable: ajaxProducts.dataset.hasUnwrappable === "true"
          });

          var cartTags = (ajaxProducts.dataset.cartTags || "")
            .split(",")
            .map(function (tag) { return tag.trim(); })
            .filter(Boolean);

          updateAddonUpsellRequirements(cartTags);
          updateEmbroideryCartRule(cartData, cartTags);
        } else {
          updateGiftWrapAvailability(cartData);
        }

        updateCartSummary(cartData);
        updateCartShippingText(cartData);
        renderFreeShippingBarFromCart(cartData);
        updateCartCountBubble(cartData);
        toggleEmptyCart(cartData);
        bindCartEvents();
        updateCartUpsells(cartData);
        if (rememberedFocus) {
          restoreCartFocus(currentProducts, rememberedFocus);
        }
        announceCartUpdated(cartData);
      })
      .catch(function (error) {
        console.error("Fejl ved refresh af cart drawer:", error);
      })
      .finally(function () {
        refreshInProgress = false;
      });
  }

  window.refreshCartDrawerContents = refreshCartContents;

  function initCartDrawer() {
    bindCartEvents();

    fetch(CART_URL, {
      credentials: "same-origin",
      cache: "no-store"
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        updateCartSummary(data);
        updateCartShippingText(data);
        renderFreeShippingBarFromCart(data);
        updateCartCountBubble(data);
        toggleEmptyCart(data);
        updateGiftWrapAvailability(data);
        updateCartUpsells(data);
      })
      .catch(function (error) {
        console.error("Fejl ved init af cart drawer:", error);
      });

    document.addEventListener("ajaxProduct:added", function () {
      refreshCartContents();
    });

    document.addEventListener("cart:updated", function () {
      fetch(CART_URL, {
        credentials: "same-origin",
        cache: "no-store"
      })
        .then(function (res) {
          return res.json();
        })
        .then(function (data) {
          updateCartSummary(data);
          updateCartShippingText(data);
          renderFreeShippingBarFromCart(data);
          updateCartCountBubble(data);
          toggleEmptyCart(data);
          updateGiftWrapAvailability(data);
        })
        .catch(function (error) {
          console.error("Fejl ved cart:updated:", error);
        });
    });
  }

  // Sengesaet: vis kun pakkebilledet for den valgte dynebetraek-stoerrelse (1 eller 2 puder).
  // Et billede der er variantbillede for en ANDEN variant end den valgte, skjules i slider og
  // thumbnails; alle oevrige billeder vises altid. Styres alene af variantbillederne i admin.
  // Genbruger temaets image-set-sti i initProductSlider (cellSelector + .hide paa thumbs) via
  // produktsektionens instans, saa theme.js er uroert.
  function initBeddingVariantImages(section, duvetSelect, variants) {
    var slider = section.querySelector("[data-product-photos]");
    if (!slider || !Array.isArray(variants)) return;

    var variantMediaIds = {};
    variants.forEach(function (v) {
      if (v && v.featured_media && v.featured_media.id) variantMediaIds[String(v.featured_media.id)] = true;
    });
    // Kun relevant naar varianterne har forskellige billeder
    if (Object.keys(variantMediaIds).length < 2) return;

    // Slides og thumbs renderes i samme loop over product.media; media-id hentes fra thumbens data-id.
    // Liquid-indekset gemmes i data-wl-index, da data-index omnummereres til slidens aktuelle position.
    var slides = Array.from(slider.querySelectorAll(".product-main-slide"));
    var thumbItems = {};
    section.querySelectorAll(".product__thumb-item").forEach(function (item) {
      thumbItems[item.dataset.index] = item;
    });
    slides.forEach(function (slide) {
      var thumb = thumbItems[slide.dataset.index];
      var link = thumb ? thumb.querySelector("[data-id]") : null;
      slide.dataset.wlIndex = slide.dataset.index;
      slide.dataset.wlMediaId = link ? String(link.dataset.id) : "";
    });
    if (slides.length < 2) return;

    var currentMediaId = null;

    function getInstance() {
      var instances = (window.theme && theme.sections && theme.sections.instances) || [];
      return instances.find(function (instance) {
        return instance && instance.container === section && typeof instance.initProductSlider === "function";
      });
    }

    function apply(variantId) {
      var variant = variants.find(function (v) {
        return String(v.id) === String(variantId);
      });
      var mediaId = variant && variant.featured_media ? String(variant.featured_media.id) : "";
      if (mediaId === currentMediaId) return;

      var instance = getInstance();
      if (!instance) return;
      currentMediaId = mediaId;

      var position = 0;
      var startIndex = 0;
      slides.forEach(function (slide) {
        var id = slide.dataset.wlMediaId;
        var hidden = mediaId !== "" && id !== mediaId && variantMediaIds[id] === true;
        var thumb = thumbItems[slide.dataset.wlIndex];

        if (thumb) thumb.classList.toggle("hide", hidden);
        if (hidden) {
          slide.setAttribute("data-wl-variant-hidden", "");
          slide.dataset.index = "-1";
        } else {
          slide.removeAttribute("data-wl-variant-hidden");
          if (id === mediaId) startIndex = position;
          slide.dataset.index = String(position);
          position++;
        }
      });

      // Temaets image-set-sti: initProductSlider bruger cellSelector fra imageSetArguments,
      // og thumbnails med .hide springes over af slideshowets childNav.
      instance.settings.imageSetName = "wl-bedding-size";
      instance.updateImageSetThumbs = function () {};
      instance.imageSetArguments = function () {
        // Flickity.destroy laegger de viste slides sidst; genskab Liquid-raekkefoelgen
        slides.forEach(function (slide) {
          slider.appendChild(slide);
        });
        instance.settings.currentSlideIndex = startIndex;
        return {
          cellSelector: ".product-main-slide:not([data-wl-variant-hidden])",
          initialIndex: startIndex
        };
      };

      try {
        instance.initProductSlider(variant);
      } catch (error) {
        console.error("Kunne ikke opdatere produktbilleder:", error);
      }
    }

    duvetSelect.addEventListener("change", function () {
      apply(this.value);
    });

    if (getInstance()) {
      apply(duvetSelect.value);
    } else {
      // Temaets sektioner er normalt registreret foer custom.js koerer; ellers vent paa load
      window.addEventListener("load", function () {
        apply(duvetSelect.value);
      }, { once: true });
    }
  }

  function initBeddingBundle(scope = document) {
    const pickers = scope.querySelectorAll("[data-bedding-bundle-picker]");

    pickers.forEach(function (picker) {
      if (picker.dataset.beddingBundleBound === "true") return;
      picker.dataset.beddingBundleBound = "true";

      const section = picker.closest(".product-section");
      if (!section) return;

      const duvetSelect = section.querySelector("[data-bedding-duvet-select]");
      const pillowSelect = section.querySelector("[data-bedding-pillow-select]");
      const helper = section.querySelector("[data-bedding-bundle-helper]");
      const pillowVariantIdInput = section.querySelector("[data-linked-pillow-variant-id]");
      const pillowVariantLabelInput = section.querySelector("[data-linked-pillow-variant-label]");
      const pillowQuantityInput = section.querySelector("[data-linked-pillow-quantity]");
      const pillowCountLabel = section.querySelector("[data-bedding-pillow-count-label]");
      const form = section.querySelector('form[action*="/cart/add"]');
      const addToCartBtns = section.querySelectorAll(".add-to-cart, [data-add-to-cart]");
      const addToCartTexts = section.querySelectorAll("[data-add-to-cart-text]");
      const productTitle = section.dataset.productTitle || "";
      const defaultAddToCartText = addToCartTexts.length
        ? addToCartTexts[0].textContent.trim()
        : wlString("wlAddToCart", "Tilføj til kurv");

      if (!duvetSelect || !pillowSelect || !form) return;

      const variantJsonEl = section.querySelector("[data-variant-json]");
      const variants = variantJsonEl ? parseJSONSafe(variantJsonEl.textContent, []) : [];

      function getFirstAvailablePillowOption() {
        return Array.from(pillowSelect.options).find(function (option) {
          return !option.disabled;
        });
      }

      function ensureValidPillowSelection() {
        const selectedOption = pillowSelect.options[pillowSelect.selectedIndex];
        if (selectedOption && !selectedOption.disabled) return selectedOption;

        const firstAvailable = getFirstAvailablePillowOption();
        if (firstAvailable) {
          pillowSelect.value = firstAvailable.value;
          return firstAvailable;
        }

        return selectedOption || null;
      }

      // Pudeantal pr. saet: fra data-pillow-counts (variant-metafelt custom.pillowcase_quantity,
      // renderet i product-template.liquid), ellers den gamle titel-regel som noedloesning.
      const pillowCounts = parseJSONSafe(picker.dataset.pillowCounts || "{}", {}) || {};

      function getPillowCount(variantId, title) {
        const fromMetafield = parseInt(pillowCounts[String(variantId)], 10);
        if (fromMetafield >= 1) return fromMetafield;
        if (!title) return 1;
        return title.includes("200x200") || title.includes("200x220") || title.includes("240x220") ? 2 : 1;
      }

      function setAddToCartState(isAvailable, soldOutText) {
        const text = isAvailable ? defaultAddToCartText : soldOutText || wlString("soldOut", "Midlertidigt udsolgt");

        addToCartBtns.forEach(function (btn) {
          btn.disabled = !isAvailable;
          btn.setAttribute("aria-disabled", String(!isAvailable));

          if (!addToCartTexts.length) {
            btn.textContent = text;
          }
        });

        addToCartTexts.forEach(function (el) {
          el.textContent = text;
        });
      }

      function updateMainVariantUI(variantId) {
        const variant = variants.find(function (v) {
          return String(v.id) === String(variantId);
        });

        if (!variant) return;

        const priceEl = section.querySelector("[data-product-price]");
        const compareWrapEl = section.querySelector("[data-product-price-wrap]");
        const compareEl = section.querySelector("[data-compare-price]");
        const saveEl = section.querySelector("[data-save-price]");
        const unitPriceWrapEl = section.querySelector("[data-unit-price-wrapper]");
        const unitPriceEl = section.querySelector("[data-unit-price]");
        const unitBaseEl = section.querySelector("[data-unit-base]");
        const skuEl = section.querySelector("[data-sku]");
        const hiddenIdInput = form.querySelector('[name="id"]');

        if (hiddenIdInput) {
          hiddenIdInput.value = variant.id;
        }

        if (priceEl) {
          priceEl.textContent = formatMoney(variant.price);
          if (variant.compare_at_price > variant.price) {
            priceEl.classList.add("on-sale");
          } else {
            priceEl.classList.remove("on-sale");
          }
        }

        if (compareWrapEl && compareEl) {
          if (variant.compare_at_price > variant.price) {
            compareWrapEl.classList.remove("hide");
            compareEl.textContent = formatMoney(variant.compare_at_price);
          } else {
            compareWrapEl.classList.add("hide");
            compareEl.textContent = "";
          }
        }

        if (saveEl) {
          if (variant.compare_at_price > variant.price) {
            const savedAmount = variant.compare_at_price - variant.price;
            saveEl.classList.remove("hide");
            saveEl.textContent = wlString("wlSave", "Spar [amount]").replace("[amount]", formatMoney(savedAmount));
          } else {
            saveEl.classList.add("hide");
            saveEl.textContent = "";
          }
        }

        if (unitPriceWrapEl && unitPriceEl && unitBaseEl) {
          if (variant.unit_price_measurement && variant.unit_price) {
            unitPriceWrapEl.classList.remove("hide");
            unitPriceEl.textContent = formatMoney(variant.unit_price);

            let base = "";
            if (variant.unit_price_measurement.reference_value !== 1) {
              base += variant.unit_price_measurement.reference_value;
            }
            base += variant.unit_price_measurement.reference_unit;
            unitBaseEl.textContent = base;
          } else {
            unitPriceWrapEl.classList.add("hide");
            unitPriceEl.textContent = "";
            unitBaseEl.textContent = "";
          }
        }

        if (skuEl) {
          skuEl.textContent = variant.sku || "";
        }

        const url = new URL(window.location.href);
        url.searchParams.set("variant", variant.id);
        window.history.replaceState({}, "", url.toString());
      }

      function updateHelper(showMessage) {
  const selectedDuvetOption = duvetSelect.options[duvetSelect.selectedIndex] || null;
  const selectedDuvetText = selectedDuvetOption ? selectedDuvetOption.text : "";
  const selectedDuvetValue = duvetSelect.value || "";

  const hasAvailableDuvetOption = Array.from(duvetSelect.options).some(function(option) {
    return option.value !== "" && option.getAttribute("data-soldout") !== "true";
  });

  const selectedPillowOption = ensureValidPillowSelection();
  const pillowCount = getPillowCount(selectedDuvetValue, selectedDuvetText);
        Array.from(pillowSelect.options).forEach(function(option) {
  var baseLabel = option.getAttribute("data-base-label") || option.getAttribute("data-label") || option.text;
  var isPlaceholder = option.value === "";
  // Udsolgt-tekst ogsaa naar preorder goer varianten koebbar (data-inventory-soldout fra Liquid)
  var isLabelSoldout = option.disabled || option.getAttribute("data-inventory-soldout") === "true";

  if (isPlaceholder) {
    option.textContent = wlString("wlChooseSize", "Vælg størrelse");
    return;
  }

  option.textContent = baseLabel + " (" + wlString("wlPcs", "[count] stk.").replace("[count]", pillowCount) + ")" + (isLabelSoldout ? " - " + wlString("wlSoldOut", "Udsolgt") : "");
});

pillowSelect.disabled = false;

        if (pillowQuantityInput) pillowQuantityInput.value = pillowCount;
if (pillowCountLabel) pillowCountLabel.textContent = wlString("wlPcs", "[count] stk.").replace("[count]", pillowCount);

if (!hasAvailableDuvetOption || !selectedDuvetValue) {
  if (pillowVariantIdInput) pillowVariantIdInput.value = "";
  if (pillowVariantLabelInput) pillowVariantLabelInput.value = "";

  if (helper) {
    helper.textContent = wlString("wlDuvetSoldOutAll", "Dynebetræk er midlertidigt udsolgt i alle størrelser.");
    helper.classList.add("is-visible");
  }

  setAddToCartState(false, wlString("soldOut", "Midlertidigt udsolgt"));
  return;
}
if (!selectedPillowOption || selectedPillowOption.disabled) {
  if (pillowVariantIdInput) pillowVariantIdInput.value = "";
  if (pillowVariantLabelInput) pillowVariantLabelInput.value = "";

  if (helper) {
    helper.textContent = wlString("wlPillowSoldOutAll", "Pudebetræk er midlertidigt udsolgt i alle størrelser.");
    helper.classList.add("is-visible");
  }

  setAddToCartState(false, wlString("soldOut", "Midlertidigt udsolgt"));
  return;
}

        const selectedPillowLabel = selectedPillowOption.getAttribute("data-label") || selectedPillowOption.text;
       

        if (pillowVariantIdInput) pillowVariantIdInput.value = pillowSelect.value;
        if (pillowVariantLabelInput) pillowVariantLabelInput.value = selectedPillowLabel;

        if (helper && template) {
          helper.textContent = template.replace("[SIZE]", selectedPillowLabel);
          if (showMessage) helper.classList.add("is-visible");
        }

        const mainVariant = variants.find(function (v) {
          return String(v.id) === String(duvetSelect.value);
        });

        const isAvailable = !!selectedPillowOption && !selectedPillowOption.disabled && (!mainVariant || mainVariant.available);
        setAddToCartState(isAvailable, wlString("soldOut", "Midlertidigt udsolgt"));
      }

      // Bundle-vaelgeren bruger ikke temaets variantvaelger, saa temaets
      // lagerstatus-blok ("Paa lager", "Kun X tilbage", "Forventes paa lager")
      // blev foerst opdateret ved reload. Vi kalder temaets egen updateInventory
      // direkte paa produktsektionens instans i stedet for at udsende
      // variantChange, saa vi ikke ogsaa udloeser knaptekst, billedskift,
      // butikslager og BIS-logik, der styres af bundle-koden her.
      function updateThemeInventory(variantId) {
        if (!section.querySelector("[data-product-inventory]")) return;
        if (!section.querySelector("[data-incoming-inventory]")) return;

        const themeSections = window.theme && theme.sections;
        const instances = (themeSections && themeSections.instances) || [];

        const productInstance = instances.find(function (instance) {
          return instance && instance.container === section && typeof instance.updateInventory === "function";
        });

        if (!productInstance) return;

        const variant = variants.find(function (v) {
          return String(v.id) === String(variantId);
        }) || null;

        try {
          productInstance.updateInventory({ detail: { variant: variant } });
        } catch (error) {
          console.error("Kunne ikke opdatere lagerstatus:", error);
        }
      }

      duvetSelect.addEventListener("change", function () {
        updateMainVariantUI(this.value);
        updateHelper(true);
        updateThemeInventory(this.value);
      });

      pillowSelect.addEventListener("change", function () {
        updateHelper(true);
      });

      updateMainVariantUI(duvetSelect.value);
      updateHelper(true);
      initBeddingVariantImages(section, duvetSelect, variants);

      let bundleSubmitInProgress = false;

      form.addEventListener(
        "submit",
        async function (event) {
          if (!section.querySelector("[data-bedding-bundle-picker]")) return;

          event.preventDefault();
          event.stopImmediatePropagation();

          if (bundleSubmitInProgress) return;

          const mainVariantId = duvetSelect.value;
          // form.elements finder ogsaa antal-feltet naar det staar uden for
          // form-elementet og kun er koblet via form-attributten
          const mainQtyField = form.elements.quantity || form.querySelector('[name="quantity"]');
          const mainQuantity = Math.max(1, parseInt(mainQtyField?.value || 1, 10) || 1);
          const pillowVariantId = pillowVariantIdInput?.value || "";
          const pillowLabel = pillowVariantLabelInput?.value || "";
          const pillowPerSet = parseInt(pillowQuantityInput?.value || 1, 10);
          const pillowTotalQty = mainQuantity * pillowPerSet;

          if (!pillowVariantId) {
            console.error("Ingen tilgængelig pudebetræk variant valgt");
            return;
          }

          const submitBtn = form.querySelector(".add-to-cart, [data-add-to-cart]");
          const submitText = form.querySelector("[data-add-to-cart-text]");
          const originalText = submitText ? submitText.textContent : "";

          bundleSubmitInProgress = true;
          if (submitBtn) submitBtn.disabled = true;
          if (submitText) submitText.textContent = wlString("wlAdding", "Tilføjer...");

          const parentKey = "parent_" + mainVariantId;
          const childKey = "child_" + pillowVariantId;

          try {
            const response = await fetch(CART_ADD_URL, {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
              },
              body: JSON.stringify({
                items: [
                  {
                    id: parseInt(mainVariantId, 10),
                    quantity: mainQuantity,
                    properties: {
                      _bundle_type: "bedding_set",
                      _bundle_role: "parent",
                      _bundle_key: parentKey,
                      _child_link_key: childKey,
                      _linked_pillow_variant_id: String(pillowVariantId),
                      _linked_pillow_quantity_per_set: String(pillowPerSet)
                    }
                  },
                  {
                    id: parseInt(pillowVariantId, 10),
                    quantity: pillowTotalQty,
                    properties: {
                      _bundle_type: "bedding_set",
                      _bundle_role: "child",
                      _bundle_key: childKey,
                      _bundle_parent_product_title: productTitle,
                      _bundle_pillow_size: pillowLabel
                    }
                  }
                ]
              })
            });

            if (!response.ok) {
              throw new Error(await readCartError(response, (window.theme && theme.strings && theme.strings.bundleAddError) || "Fejl ved tilføjelse"));
            }

            if (window.refreshCartDrawerContents) {
              // Ét event: custom.js' egen lytter renderer draweren (refreshCartContents),
              // temaets CartDrawer aabner den. Ingen ekstra refresh/cart:updated/cart:open.
              document.dispatchEvent(new CustomEvent("ajaxProduct:added", { detail: { product: null } }));
            } else {
              window.location.href = CART_PAGE_URL;
            }
          } catch (error) {
            console.error("Bundle Error:", error);
            showFormError(form, error && error.message);
          } finally {
            bundleSubmitInProgress = false;
            updateHelper(true);

            if (submitBtn) submitBtn.disabled = false;
            if (submitText) submitText.textContent = originalText || wlString("wlAddToCart", "Tilføj til kurv");
          }
        },
        true
      );
    });
  }

  // Klaviyo back-in-stock under Forudbestil-knappen (Essential Preorder).
  // Markup renderes skjult af snippets/wl-preorder-bis.liquid; her styres synlighed og tilmelding.
  function initPreorderBis(scope = document) {
    const blocks = scope.querySelectorAll("[data-wl-preorder-bis]");
    if (!blocks.length) return;

    function getKlaviyoCompanyId() {
      const scripts = document.querySelectorAll('script[src*="klaviyo"]');
      for (const script of scripts) {
        try {
          const url = new URL(script.src, window.location.href);
          const param = url.searchParams.get("company_id");
          if (param) return param;
          const match = url.pathname.match(/\/onsite\/js\/([A-Za-z0-9]+)\/klaviyo/);
          if (match) return match[1];
        } catch (error) {
          // Ugyldig script-src springes over
        }
      }
      return "";
    }

    // Markerer profilen med marked (fx wl_marked = NO) FOER tilmeldingen, saa Klaviyos flowfiltre
    // allerede ser markeringen, naar BIS-bekraeftelsen sendes. Fejl her paavirker ikke tilmeldingen.
    function markProfileMarket(email, market) {
      const companyId = getKlaviyoCompanyId();
      if (!companyId || !email || !market) return Promise.resolve();
      return fetch("https://a.klaviyo.com/client/profiles/?company_id=" + encodeURIComponent(companyId), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          revision: "2024-10-15"
        },
        body: JSON.stringify({
          data: {
            type: "profile",
            attributes: {
              email: email,
              properties: { wl_marked: market }
            }
          }
        })
      }).catch(function (error) {
        console.error("Klaviyo-markering fejlede:", error);
      });
    }

    blocks.forEach(function (block) {
      if (block.dataset.wlBisBound === "true") return;
      block.dataset.wlBisBound = "true";

      const companyId = getKlaviyoCompanyId();
      if (!companyId) return;

      const section = block.closest(".product-section");
      const jsonEl = block.querySelector("[data-wl-bis-variants]");
      const soldOutByVariant = jsonEl ? parseJSONSafe(jsonEl.textContent, {}) : {};
      const toggle = block.querySelector("[data-wl-bis-toggle]");
      const form = block.querySelector("[data-wl-bis-form]");
      const emailInput = block.querySelector("[data-wl-bis-email]");
      const message = block.querySelector("[data-wl-bis-message]");

      if (!toggle || !form || !emailInput || !message) return;

      let currentVariantId = block.dataset.initialVariant || "";
      let submitInProgress = false;

      function readVariantIdFromForm() {
        if (!section) return "";
        const input = section.querySelector('.product-single__form [name="id"]');
        return input && input.value ? String(input.value) : "";
      }

      function setMessage(text, type) {
        message.textContent = text || "";
        message.hidden = !text;
        message.classList.toggle("note--success", type === "success");
        message.classList.toggle("errors", type === "error");
        // Fejl laeses op straks (role=alert) og markerer e-mail-feltet som ugyldigt
        message.setAttribute("role", type === "error" ? "alert" : "status");
        if (type === "error") {
          emailInput.setAttribute("aria-invalid", "true");
        } else {
          emailInput.removeAttribute("aria-invalid");
        }
      }

      function setExpanded(expanded) {
        toggle.setAttribute("aria-expanded", String(expanded));
        form.hidden = !expanded;
      }

      function updateVisibility() {
        const isSoldOut = soldOutByVariant[String(currentVariantId)] === true;
        block.hidden = !isSoldOut;
        if (!isSoldOut) {
          setExpanded(false);
          setMessage("", "");
        }
      }

      function setCurrentVariant(variantId) {
        const next = variantId ? String(variantId) : "";
        if (next === currentVariantId) return;
        currentVariantId = next;
        setMessage("", "");
        updateVisibility();
      }

      toggle.addEventListener("click", function () {
        const expanded = toggle.getAttribute("aria-expanded") === "true";
        setExpanded(!expanded);
        if (!expanded) emailInput.focus();
      });

      form.addEventListener("submit", function (event) {
        event.preventDefault();
        if (submitInProgress) return;

        if (!emailInput.checkValidity()) {
          setMessage(block.dataset.textInvalid, "error");
          emailInput.focus();
          return;
        }

        const variantId = currentVariantId || readVariantIdFromForm();
        if (!variantId) {
          setMessage(block.dataset.textError, "error");
          return;
        }

        submitInProgress = true;
        const email = emailInput.value.trim();
        const submitBtn = form.querySelector('[type="submit"]');
        if (submitBtn) submitBtn.disabled = true;
        setMessage("", "");

        markProfileMarket(email, block.dataset.wlBisMarket)
          .then(function () {
            return fetch(
              "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=" +
                encodeURIComponent(companyId),
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  revision: "2024-10-15"
                },
                body: JSON.stringify({
                  data: {
                    type: "back-in-stock-subscription",
                    attributes: {
                      channels: ["EMAIL"],
                      profile: {
                        data: {
                          type: "profile",
                          attributes: { email: email }
                        }
                      }
                    },
                    relationships: {
                      variant: {
                        data: {
                          type: "catalog-variant",
                          id: "$shopify:::$default:::" + variantId
                        }
                      }
                    }
                  }
                })
              }
            );
          })
          .then(function (response) {
            if (!response.ok) throw new Error("Klaviyo-svar " + response.status);
            setExpanded(false);
            setMessage(block.dataset.textSuccess, "success");
          })
          .catch(function (error) {
            console.error("Klaviyo back-in-stock fejlede:", error);
            setMessage(block.dataset.textError, "error");
          })
          .finally(function () {
            submitInProgress = false;
            if (submitBtn) submitBtn.disabled = false;
          });
      });

      if (section) {
        section.addEventListener("variantChange", function (event) {
          const variant = event.detail ? event.detail.variant : null;
          setCurrentVariant(variant ? variant.id : "");
        });

        // Fallback for variantskift der ikke udloeser variantChange (fx bundle-vaelgeren)
        section.addEventListener("change", function () {
          window.setTimeout(function () {
            const fromForm = readVariantIdFromForm();
            if (fromForm) setCurrentVariant(fromForm);
          }, 0);
        });
      }

      const initialFromForm = readVariantIdFromForm();
      if (initialFromForm) currentVariantId = initialFromForm;
      updateVisibility();
    });
  }

  // Alle variant-lyttere bruger temaets officielle 'variantChange' (dispatches paa .product-section-containeren,
  // bobler ikke, derfor capture=true paa document). Den tidligere butiks-tilfoejede 'variant:change' i theme.js er fjernet.
  function initVariantChangeHelpers() {
    if (document.body.dataset.variantChangeHelperBound === "true") return;
    document.body.dataset.variantChangeHelperBound = "true";

    document.addEventListener("variantChange", function (event) {
      const variant = event.detail?.variant;
      if (!variant) return;

      const url = new URL(window.location.href);
      url.searchParams.set("variant", variant.id);
      window.history.replaceState({}, "", url.toString());

      document.querySelectorAll('.custom-related-product form[action*="/cart/add"]').forEach(function (form) {
        const input = form.querySelector('input[name="id"]');
        const select = form.querySelector('select[name="id"]');

        if (input) input.value = variant.id;
        if (select && select.querySelector(`option[value="${variant.id}"]`)) {
          select.value = String(variant.id);
        }
      });
    }, true);
  }

  function initAddonUpsells() {
    if (document.body.dataset.addonUpsellBound === "true") return;
    document.body.dataset.addonUpsellBound = "true";

    document.addEventListener("click", function (event) {
      var toggle = event.target.closest("[data-addon-toggle]");
      if (!toggle) return;

      var wrapper = toggle.closest("[data-addon-upsell]");
      var panel = wrapper ? wrapper.querySelector(".wl-addon-upsell__panel") : null;
      if (!panel) return;

      var isOpen = toggle.getAttribute("aria-expanded") === "true";
      toggle.setAttribute("aria-expanded", isOpen ? "false" : "true");
      panel.hidden = isOpen;
    });

    document.addEventListener("change", function (event) {
      var select = event.target.closest("[data-addon-variant-select]");
      if (!select) return;

      var wrapper = select.closest("[data-addon-upsell]");
      var addButton = wrapper ? wrapper.querySelector(".add-upsell-to-cart") : null;
      if (addButton) addButton.dataset.id = select.value;
    });
  }

  function initVideoJump(scope) {
    // Play-genvej paa produktsiden: svinger hovedslideren over til foerste video.
    // Markup i snippets/product-images.liquid, CSS i wonderliving.css.liquid.
    scope.querySelectorAll("[data-wl-video-jump]").forEach(function (button) {
      if (button.dataset.wlVideoJumpBound === "true") return;
      button.dataset.wlVideoJumpBound = "true";

      var photos = button.closest(".product__main-photos");
      var slider = photos ? photos.querySelector("[data-product-photos]") : null;
      var section = button.closest("[data-section-id]");
      var index = parseInt(button.dataset.videoIndex, 10);
      if (!slider || !section || isNaN(index)) return;

      function goToVideo() {
        var instance =
          window.theme && theme.sections && typeof theme.sections._findInstance === "function"
            ? theme.sections._findInstance(section.dataset.sectionId)
            : null;

        if (instance && instance.flickity && typeof instance.flickity.goToSlide === "function") {
          // Sengesaet skjuler billeder for den anden stoerrelse (initBeddingVariantImages), saa
          // slidens position kan afvige fra Liquid-indekset: brug dens aktuelle data-index.
          var videoSlide = slider.querySelector('.product-main-slide[data-wl-index="' + index + '"]');
          var slideIndex = videoSlide ? parseInt(videoSlide.dataset.index, 10) : index;
          instance.flickity.goToSlide(isNaN(slideIndex) ? index : slideIndex);
          return;
        }

        // Fallback: temaets egen thumbnail-navigation
        var thumb = section.querySelector('.product__thumb-item[data-index="' + index + '"] a');
        if (thumb) thumb.click();
      }

      function syncVisibility() {
        var selected = slider.querySelector(".product-main-slide.is-selected");
        var onVideo = !!(selected && selected.querySelector(".product__video-wrapper, .product-video-trigger"));
        button.classList.toggle("wl-video-jump--hidden", onVideo);
      }

      button.addEventListener("click", goToVideo);

      // Flickity skifter .is-selected paa slides; skjul knappen mens videoen er aktiv.
      new MutationObserver(syncVisibility).observe(slider, {
        attributes: true,
        attributeFilter: ["class"],
        subtree: true
      });
      syncVisibility();
    });
  }

  function initBundleOffer(scope = document) {
    // "Koeb 2 saet"-boksen: regner 2 stk-prisen ud fra den valgte variants pris.
    // Markup i snippets/wl-bundle-offer.liquid, CSS i wonderliving.css.liquid.
    // Opdateres baade via temaets variantChange (standard-variantvaelger, capture paa document) og via
    // change-haendelser i sektionen (bundle-vaelgeren udsender bevidst ikke variantChange).

    function formatNumber(cents) {
      // Tal uden valuta og uden oerer, med butikkens tusindtalsseparator
      var shopFormat = (window.theme && theme.settings && theme.settings.moneyFormat) || "";
      var format = shopFormat.indexOf("comma_separator") !== -1
        ? "{{amount_no_decimals_with_comma_separator}}"
        : "{{amount_no_decimals}}";

      if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === "function") {
        return theme.Currency.formatMoney(Math.round(cents), format);
      }
      return String(Math.round(cents / 100));
    }

    function sizeDiscount(box, variant) {
      // Rabattype "per_size": "80x200:109, 90x200:99" matchet praecist mod variantens optionvaerdier
      var options = (variant && variant.options) || [variant && variant.option1, variant && variant.option2, variant && variant.option3];
      var values = options
        .filter(function (o) { return o != null; })
        .map(function (o) { return String(o).trim().toLowerCase(); });
      var result = 0;

      (box.dataset.sizeDiscounts || "").split(",").forEach(function (pair) {
        var kv = pair.split(":");
        if (kv.length < 2) return;
        var key = kv[0].trim().toLowerCase();
        if (key && values.indexOf(key) !== -1) {
          result = parseFloat(kv[1]) || 0;
        }
      });

      return result;
    }

    function updateBox(box, variant) {
      var price = variant ? Number(variant.price) || 0 : 0;
      var compare = variant && variant.compare_at_price ? Number(variant.compare_at_price) || 0 : 0;
      var type = box.dataset.discountType;
      var value = parseFloat(box.dataset.discountValue) || 0;
      var double = price * 2;
      var twoPrice = 0;
      var saving = 0;

      if (type === "percentage") {
        saving = Math.round((double * value) / 100);
        twoPrice = double - saving;
      } else if (type === "fixed_price") {
        twoPrice = Math.round(value * 100);
        saving = double - twoPrice;
      } else if (type === "per_size") {
        saving = Math.round(sizeDiscount(box, variant) * 100);
        twoPrice = double - saving;
      } else {
        saving = Math.round(value * 100);
        twoPrice = double - saving;
      }

      var hide =
        !variant ||
        price <= 0 ||
        saving <= 0 ||
        twoPrice <= 0 ||
        (box.dataset.hideOnSale === "true" && compare > price);

      box.classList.toggle("wl-bundle-offer--hidden", hide);
      if (hide) return;

      var title = box.querySelector("[data-wl-bundle-offer-title]");
      if (title) {
        title.textContent = (box.dataset.titleTemplate || "")
          .replace(/\[pris\]/g, formatNumber(twoPrice))
          .replace(/\[besparelse\]/g, formatNumber(saving));
      }
    }

    scope.querySelectorAll("[data-wl-bundle-offer]").forEach(function (box) {
      if (box.dataset.wlBundleOfferBound === "true") return;
      box.dataset.wlBundleOfferBound = "true";

      var section = box.closest(".product-section") || box.closest("[data-section-id]");
      if (!section) return;

      // Kompakt linje der kun skal vises naar boks-udgaven er scrollet ud af syne (over viewporten).
      // Uden boks-udgave paa siden, eller uden IntersectionObserver, vises linjen altid.
      if (box.dataset.showWhenBoxHidden === "true") {
        var referenceBox = section.querySelector("[data-wl-bundle-offer]:not([data-wl-bundle-offer-compact])");

        if (!referenceBox || !("IntersectionObserver" in window)) {
          box.classList.remove("wl-bundle-offer--waiting");
        } else {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
              box.classList.toggle("wl-bundle-offer--waiting", !scrolledPast);
            });
          }).observe(referenceBox);
        }
      }

      // Fallback for variantskift der ikke udloeser variantChange (fx bundle-vaelgeren):
      // laes valgt variant-id fra formularen og slaa pris op i sektionens variant-JSON.
      // Variant-id laeses foerst fra det felt der blev aendret (bundle-vaelgerens dyne-select),
      // fordi formularens [name="id"] er tom for udsolgte varianter, og boksen skal ogsaa vises der.
      section.addEventListener("change", function (event) {
        var target = event.target;
        window.setTimeout(function () {
          var jsonEl = section.querySelector("[data-variant-json]");
          if (!jsonEl) return;

          var variants = parseJSONSafe(jsonEl.textContent, []);
          var findVariant = function (id) {
            if (!id) return null;
            return variants.find(function (v) {
              return String(v.id) === String(id);
            }) || null;
          };

          var variant = target && target.value ? findVariant(target.value) : null;
          if (!variant) {
            var input = section.querySelector('.product-single__form [name="id"]');
            variant = input ? findVariant(input.value) : null;
          }
          if (variant) updateBox(box, variant);
        }, 0);
      });
    });

    if (document.body.dataset.wlBundleOfferBound === "true") return;
    document.body.dataset.wlBundleOfferBound = "true";

    document.addEventListener("variantChange", function (event) {
      var variant = event.detail ? event.detail.variant : null;

      document.querySelectorAll("[data-wl-bundle-offer]").forEach(function (box) {
        if (
          variant &&
          variant.product_id &&
          box.dataset.productId &&
          String(variant.product_id) !== String(box.dataset.productId)
        ) {
          return;
        }
        updateBox(box, variant);
      });
    }, true);
  }

  // Variant-knapper (snippets/variant-button.liquid): naar der vaelges stoerrelse, skjules de
  // vaegt-muligheder der ikke findes for den stoerrelse (data-available-variants). Foer laa dette som
  // ét inline-script PR option, der hver bandt paa ALLE wrappers, saa handleren koerte N gange pr. klik.
  function initVariantOptionFilter() {
    if (document.body.dataset.variantOptionFilterBound === "true") return;
    document.body.dataset.variantOptionFilterBound = "true";

    function applyFilter(wrapper) {
      const selected = wrapper.querySelector('input[type="radio"]:checked');
      if (!selected) return;
      const selectedValue = selected.value;
      const isSelectedSize = wrapper.getAttribute("data-option-type") === "size";
      const section = wrapper.closest(".product-section") || document;

      section.querySelectorAll(".variant-wrapper").forEach(function (other) {
        if (other === wrapper) return;
        const isWeightWrapper = other.getAttribute("data-option-type") === "weight";
        if (!isSelectedSize && !isWeightWrapper) return;

        other.querySelectorAll(".variant-input").forEach(function (opt) {
          const available = (opt.getAttribute("data-available-variants") || "").split("|");
          opt.classList.toggle("sr-only", !available.includes(selectedValue));
        });
      });
    }

    document.addEventListener("change", function (event) {
      const input = event.target;
      if (!input || input.type !== "radio") return;
      const wrapper = input.closest(".variant-wrapper");
      if (wrapper) applyFilter(wrapper);
    });

    document.querySelectorAll(".variant-wrapper").forEach(function (wrapper) {
      if (wrapper.querySelector('input[type="radio"]:checked')) applyFilter(wrapper);
    });
  }

  // Landevaelger (snippets/wl-country-selector.liquid): starter temaets dropdown (theme.Disclosure),
  // som saetter country_code og sender localization-formularen. data-wl-init forhindrer dobbelt-start.
  function initCountrySelectors(scope = document) {
    if (!window.theme || typeof theme.Disclosure !== "function") return;
    scope.querySelectorAll("[data-wl-country-disclosure]:not([data-wl-init])").forEach(function (el) {
      el.setAttribute("data-wl-init", "");
      new theme.Disclosure(el);
    });
  }

  // Foldud (temaets theme.collapsibles): temaet laaser en aaben boks til den pixelhoejde indholdet havde
  // ved klikket, saa teksten klippes hvis den senere ombrydes (webfont hentes, telefonen drejes, vinduet
  // aendrer bredde). Temaets collapsible--auto-height virker ikke (klassen sidder paa knappen, koden
  // tjekker boksen). Her foelger boksens hoejde indholdet, saa laenge den er aaben.
  // Synkroniseringen venter til indholdet er faldet til ro, saa temaets egen animation af indlejrede
  // foldud (mobilmenuen) ikke forstyrres.
  function initCollapsibleHeightSync() {
    if (window.__wlCollapsibleSyncBound || !("ResizeObserver" in window)) return;
    window.__wlCollapsibleSyncBound = true;

    const pending = new Set();
    let timer = null;

    function sync(container) {
      if (!container.classList.contains("is-open")) return;
      // Kun bokse temaet har givet en fast pixelhoejde (ikke '', 'auto' eller '0px')
      const current = parseFloat(container.style.height);
      if (!current) return;
      const inner = container.querySelector(".collapsible-content__inner");
      if (!inner) return;
      const height = inner.offsetHeight;
      if (height && height !== current) container.style.height = height + "px";
    }

    const observer = new ResizeObserver(function (entries) {
      entries.forEach(function (entry) {
        const container = entry.target.closest(".collapsible-content");
        if (container) pending.add(container);
      });
      clearTimeout(timer);
      timer = setTimeout(function () {
        pending.forEach(sync);
        pending.clear();
      }, 100);
    });

    // Observeres foerst ved klik, saa foldud der indsaettes senere (filtre, quick shop, sektioner) ogsaa
    // kommer med. Foraeldre-bokse tages med, fordi temaet ogsaa laaser deres hoejde ved indlejrede klik.
    document.addEventListener("click", function (event) {
      const trigger = event.target.closest(".collapsible-trigger");
      if (!trigger) return;
      let container = document.getElementById(trigger.getAttribute("aria-controls") || "");
      while (container) {
        const inner = container.querySelector(".collapsible-content__inner");
        if (inner) observer.observe(inner);
        container = container.parentNode.closest(".collapsible-content");
      }
    });
  }

  function runInitializers(scope = document) {
    initCollapsibleHeightSync();
    initVariantOptionFilter();
    initVariantSelectors(scope);
    initAjaxAddToCart(scope);
    initBeddingBundle(scope);
    initVariantMetafieldHTML();
    initPreorderBis(scope);
    initVariantChangeHelpers();
    initGlobalQtyButtons();
    initTextToggles();
    initCollectionReadMore(scope);
    initAddonUpsells();
    initVideoJump(scope);
    initBundleOffer(scope);
    initCountrySelectors(scope);
  }

  document.addEventListener("DOMContentLoaded", function () {
    runInitializers(document);
    initCartDrawer();
  });

  // Anbefalinger indlaeses af temaet via Section Rendering API; temaet udsender
  // recommendations:loaded (detail.section) naar markup'en er sat ind. Erstatter en
  // MutationObserver der koerte alle initializers ved hver DOM-mutation i sektionen.
  document.addEventListener("recommendations:loaded", function (event) {
    const scope = (event.detail && event.detail.section) || document.querySelector("product-recommendations") || document;
    runInitializers(scope);
  });

  document.addEventListener("page:loaded", function () {
    runInitializers(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    runInitializers(event.target);
    bindCartEvents();
  });
})();

